import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBackArrow = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("g", {
			fill: "currentColor",
			fillRule: "nonzero",
			children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
				d: "M9 22c4.972 0 9-4.028 9-9s-4.028-9-9-9-9 4.028-9 9 4.028 9 9 9zm.784-3.466l-4.917-4.917c-.342-.341-.342-.893 0-1.234l4.917-4.917c.337-.341.889-.341 1.23 0l.617.617c.341.337.341.889 0 1.23L7.944 13l3.687 3.687c.341.338.341.89 0 1.23l-.617.617c-.337.341-.889.341-1.23 0z",
				transform: "translate(-340.000000, -716.000000) translate(340.000000, 712.000000)"
			}) })
		})
	})
});
export default SvgBackArrow;
